import { defineComponent as _defineComponent } from 'vue';
import { createTextVNode as _createTextVNode, resolveComponent as _resolveComponent, withCtx as _withCtx, createVNode as _createVNode, toDisplayString as _toDisplayString, resolveDirective as _resolveDirective, openBlock as _openBlock, createBlock as _createBlock, withDirectives as _withDirectives, createElementVNode as _createElementVNode, createElementBlock as _createElementBlock, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue";
const _withScopeId = n => (_pushScopeId("data-v-65973526"), n = n(), _popScopeId(), n);
const _hoisted_1 = {
  class: "tab_boxs"
};
import { reactive, ref, markRaw } from "vue";
import { useRoute, useRouter } from "vue-router";
import { getCaseTopicListApi, deleteCaseTopicApi, addCaseTopicApi } from "@/service/modules/case";
import topicDialog from "./components/topic-dialog.vue";
import { ElMessageBox, ElMessage } from "element-plus";
import { QuestionFilled } from "@element-plus/icons-vue";
export default /*#__PURE__*/_defineComponent({
  __name: 'index',
  setup(__props) {
    const route = useRoute();
    const router = useRouter();
    const data_list = ref([]);
    const url = ref("");
    const page = ref({
      page: 1,
      pageSize: 15
    });
    const total = ref(0);
    const loading = ref(false);
    async function get_list() {
      loading.value = true;
      let reqdata = {
        page: page.value.page,
        pageSize: page.value.pageSize
      };
      const res = await getCaseTopicListApi(reqdata);
      data_list.value = res.data.data;
      total.value = res.data.total;
      loading.value = false;
    }
    get_list();
    const DialogVisible = ref(false);
    const DialogType = ref("add");
    function add() {
      DialogType.value = "add";
      DialogVisible.value = true;
    }
    function closeDialog() {
      DialogVisible.value = false;
    }
    const DialogData = reactive({
      name: ""
    });
    async function restData() {
      await closeDialog();
      page.value.page = await 1;
      await get_list();
    }
    function handleRoleTableItem(row) {
      DialogType.value = "edit";
      DialogData.name = row.name;
      DialogData.id = row.id;
      DialogData.img = row.img;
      DialogVisible.value = true;
    }
    async function deleteRoleTableItem(id) {
      ElMessageBox.confirm("此操作将永久删除该数据, 是否继续？", "删除分类", {
        confirmButtonText: "确定",
        cancelButtonText: "取消",
        type: "warning",
        icon: markRaw(QuestionFilled)
      }).then(async () => {
        try {
          let res = await deleteCaseTopicApi(id);
          ElMessage.success("删除成功");
          restData();
        } catch {}
      }).catch(() => {});
    }
    async function is_recommend(item) {
      let reqdata = {
        id: item.id,
        is_top: item.is_top == 1 ? 0 : 1
      };
      const res = await addCaseTopicApi(reqdata);
      if (res.code == 0) {
        ElMessage.success("操作成功");
        restData();
      }
    }
    return (_ctx, _cache) => {
      const _component_el_button = _resolveComponent("el-button");
      const _component_top_title = _resolveComponent("top-title");
      const _component_el_table_column = _resolveComponent("el-table-column");
      const _component_el_image = _resolveComponent("el-image");
      const _component_el_link = _resolveComponent("el-link");
      const _component_el_table = _resolveComponent("el-table");
      const _component_proto_pagination = _resolveComponent("proto-pagination");
      const _directive_loading = _resolveDirective("loading");
      return _openBlock(), _createElementBlock("div", null, [_createVNode(_component_top_title, {
        message: "话题管理"
      }, {
        default: _withCtx(() => [_createVNode(_component_el_button, {
          type: "primary",
          onClick: add
        }, {
          default: _withCtx(() => [_createTextVNode("新增分类")]),
          _: 1
        })]),
        _: 1
      }), _createElementVNode("div", _hoisted_1, [_withDirectives((_openBlock(), _createBlock(_component_el_table, {
        data: data_list.value,
        height: "620",
        "cell-style": {
          height: '42px',
          fontSize: '14px',
          textAlign: 'center'
        },
        "header-cell-style": {
          background: '#F7F9FB !important',
          color: '#111111',
          height: '42px',
          fontSize: '14px',
          textAlign: 'center'
        }
      }, {
        default: _withCtx(() => [_createVNode(_component_el_table_column, {
          prop: "name",
          label: "话题名称"
        }), _createVNode(_component_el_table_column, {
          prop: "img",
          label: "图片"
        }, {
          default: _withCtx(scope => [_createVNode(_component_el_image, {
            class: "img_box",
            src: scope.row.img,
            "zoom-rate": 1.2,
            "max-scale": 7,
            "min-scale": 0.2,
            "preview-src-list": [scope.row.img],
            "preview-teleported": true,
            fit: "cover"
          }, null, 8, ["src", "preview-src-list"])]),
          _: 1
        }), _createVNode(_component_el_table_column, {
          prop: "case_num",
          label: "笔记数量",
          center: ""
        }), _createVNode(_component_el_table_column, {
          prop: "ct_time",
          label: "创建时间"
        }), _createVNode(_component_el_table_column, {
          label: "操作"
        }, {
          default: _withCtx(scope => [_createVNode(_component_el_link, {
            class: "m-r-10",
            type: "primary",
            onClick: $event => handleRoleTableItem(scope.row)
          }, {
            default: _withCtx(() => [_createTextVNode("编辑")]),
            _: 2
          }, 1032, ["onClick"]), _createVNode(_component_el_link, {
            class: "m-r-10",
            type: "primary",
            onClick: $event => is_recommend(scope.row)
          }, {
            default: _withCtx(() => [_createTextVNode(_toDisplayString(scope.row.is_top == 1 ? "取消置顶" : "置顶"), 1)]),
            _: 2
          }, 1032, ["onClick"]), _createVNode(_component_el_link, {
            type: "danger",
            onClick: $event => deleteRoleTableItem(scope.row.id)
          }, {
            default: _withCtx(() => [_createTextVNode("删除")]),
            _: 2
          }, 1032, ["onClick"])]),
          _: 1
        })]),
        _: 1
      }, 8, ["data"])), [[_directive_loading, loading.value]]), _createVNode(_component_proto_pagination, {
        page: page.value,
        total: total.value,
        onCurrentChange: get_list
      }, null, 8, ["page", "total"])]), _createVNode(topicDialog, {
        "dialog-visible": DialogVisible.value,
        "item-data": DialogData,
        "dialog-type": DialogType.value,
        onCloseDialog: closeDialog,
        onRestData: restData
      }, null, 8, ["dialog-visible", "item-data", "dialog-type"])]);
    };
  }
});